import { BaseEntity } from '../../../../models';
import { Cidade } from '../../../cidade';
import { enderecoTipoPrincipal } from '../../../pessoa/endereco';
import { Pais } from '../../../pais';

export class LeadEndereco implements BaseEntity {
    readonly id: number;
    idLead: number;
    tipo: number;
    cep: string;
    logradouro: string;
    bairro: string;
    numero: string;
    complemento: string;
    idCidade: number;
    cidade: Cidade;
    contribuinteIcms: number;
    inscricaoMunicipal: string;
    inscricaoEstadual: string;
    possuiInscricaoSuframa: boolean;
    inscricaoSuframa: string;
    inscricaoProdutorRural: string;
    idCidadeSubRegiao: number;
    idCidadeSubRegiaoBairro: number;
    idPais: number;
    pais: Pais;

    constructor(tipo: number = enderecoTipoPrincipal.id) {
        this.tipo = tipo;
    }
}
